module.exports = __webpack_public_path__ + "img/partner_4.c6696ff8.png";